export default __webpack_public_path__ + "static/media/new_game.ed1bf032.png";